<app-feature-editor [title]="title" [getItems]="getIsos" [addItem]="addIso" [deleteItem]="deleteIso" (selectedIdChange)="isoIdChanged($event)">
  <div *ngIf="hasIsoObject" class="table">
    <div class="row" *ngIf="isIsosurfaceEditor">
      <div class="label-cell">Iso value</div>
      <div class="control-cell">
        <app-slider-textbox #isoValueControl [min]="minScalarValue" [max]="maxScalarValue" [precision]="6" [value]="isoValue" (change)="isoValueChanged(isoValueControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div class="row" *ngIf="!isIsosurfaceEditor">
      <div class="label-cell">Min iso value</div>
      <div class="control-cell">
        <app-slider-textbox #minIsoValueControl  [min]="minScalarValue" [max]="maxScalarValue" [precision]="6" [value]="minIsoValue" (change)="minIsoValueChanged(minIsoValueControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div class="row" *ngIf="!isIsosurfaceEditor">
      <div class="label-cell">Max iso value</div>
      <div class="control-cell">
        <app-slider-textbox #maxIsoValueControl [min]="minScalarValue" [max]="maxScalarValue" [precision]="6" [value]="maxIsoValue" (change)="maxIsoValueChanged(maxIsoValueControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Iso scalar</div>
      <div class="control-cell">
        <select #isoScalarResultSelect [value]="isoScalarResultId" (change)="isoScalarResultIdChanged(isoScalarResultSelect.value)">
            <option *ngFor="let item of scalarResults" [value]="item.id">{{item.name}}</option>
          </select>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Map scalar</div>
      <div class="control-cell">
        <select #scalarResultSelect [value]="mapScalarResultId" (change)="mapScalarResultIdChanged(scalarResultSelect.value)">
            <option *ngFor="let item of scalarResultsWithNone" [value]="item.id">{{item.name}}</option>
          </select>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Map vector</div>
      <div class="control-cell">
        <select #vectorResultSelect [value]="mapVectorResultId" (change)="mapVectorResultIdChanged(vectorResultSelect.value)">
          <option *ngFor="let item of vectorResultsWithNone" [value]="item.id">{{item.name}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Opacity</div>
      <div class="control-cell">
        <app-slider-textbox #opacityControl [value]="opacity" (change)="opacityChanged(opacityControl.value)"></app-slider-textbox>
      </div>
    </div>
  </div>
</app-feature-editor>
